export const split_string = (title) => title.split("_").join(" ");
